import { Navigate, useLocation } from "react-router-dom";
import useJWT from '../../hooks/useJWT';
// import { useAuth } from "../../context/AuthContext";

const PrivateRoute = ({ children }) => {
  const { isLoggedIn } = useJWT();
  const location = useLocation();
  
  if (!isLoggedIn) {
    // Not authenticated, redirect to login with redirect param
    return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  }

  return children;

  //return isLoggedIn ? children : <Navigate to="/login" />;
};

export default PrivateRoute;